
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Swiftdezireonrentinpune() {



    const cardData =
    {
        keyword: 'Swift Dzire on Rent in Pune',
        heading: 'Morya Cabs: Swift Dzire on Rent in Pune',
        headingDescription: 'Morya Cabs offers reliable and budget-friendly Swift Dzire rentals in Pune for local and outstation travel. Whether you are commuting within the city, heading for a weekend getaway, or need an airport transfer, our well-maintained Swift Dzire fleet ensures a smooth and hassle-free ride. With professional drivers and top-notch service, we make your journey comfortable and enjoyable.',

        top: 'Best Uses for Swift Dzire Rental with Morya Cabs',

        "topPlaces": [
    {
        "title": "Outstation Trips",
        "description": "Travel comfortably to destinations like Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, and other popular locations with a fuel-efficient and spacious Swift Dzire."
    },
    {
        "title": "Corporate Travel",
        "description": "A perfect sedan for professionals attending meetings, business trips, and corporate events in Pune and nearby cities."
    },
    {
        "title": "Airport Transfers",
        "description": "Get on-time pickup and drop services to Pune Airport and Mumbai Airport with our punctual and reliable service."
    },
    {
        "title": "Daily City Travel",
        "description": "Navigate through Pune’s busy streets with ease—ideal for office commutes, shopping, doctor visits, and personal errands."
    },
    {
        "title": "Family & Social Events",
        "description": "A great choice for weddings, parties, family gatherings, and celebrations where comfort and affordability matter."
    },
    {
        "title": "Weekend Getaways",
        "description": "Plan a relaxing weekend trip to hill stations, beaches, or religious sites with Swift Dzire’s smooth ride and excellent mileage."
    },
    {
        "title": "Long-Term Rentals",
        "description": "Need a car for an extended period? Swift Dzire is available for long-term rental at competitive rates for business or personal use."
    },
    {
        "title": "Pune Darshan & Local Sightseeing",
        "description": "Explore Pune’s historical and cultural landmarks like Shaniwar Wada, Aga Khan Palace, and Sinhagad Fort in a comfortable sedan."
    },
    {
        "title": "Student & Educational Tours",
        "description": "Ideal for students or faculty traveling to educational institutions, conferences, or research trips in Pune and nearby cities."
    },
    {
        "title": "Temple Tours & Pilgrimage Trips",
        "description": "Travel to holy places like Pandharpur, Trimbakeshwar, Tuljapur, and Bhimashankar in a comfortable and safe ride."
    }
],


"services": [
    {
      "name": "Swift Dzire Per Km Rate Pune",
      "description": "Morya Cab offers competitive Swift Dzire per km rates in Pune. Book your Swift Dzire for a comfortable and affordable journey. Our rates are transparent with no hidden charges."
    },
    {
      "name": "Swift Dzire Rent Per Km Rate Per Day",
      "description": "Morya Cab provides Swift Dzire for rent on a per-day basis in Pune. Whether you're planning a local trip or an outstation journey, we offer flexible and affordable rental rates."
    },
    {
      "name": "Swift Dzire Per Km Rate in Pune",
      "description": "For affordable travel in and around Pune, Morya Cab offers Swift Dzire per km rates. Enjoy a smooth ride in a well-maintained vehicle at a competitive price."
    },
    {
      "name": "Swift Dzire Per Km Rate in Pune",
      "description": "Book a Swift Dzire for your journey in Pune with Morya Cab. We offer affordable per km rates for local and outstation trips, ensuring a hassle-free and comfortable travel experience."
    },
    {
      "name": "Swift Dzire Per Km Rate Pimpri Chinchwad",
      "description": "Morya Cab offers Swift Dzire rentals with competitive per km rates in Pimpri Chinchwad. We provide transparent pricing and reliable service for all your travel needs."
    },
    {
      "name": "Swift Dzire Tour Service Cost",
      "description": "Morya Cab offers Swift Dzire tour services at competitive prices. Whether it's a local tour or an outstation journey, we provide the best value for your travel needs."
    },
    {
      "name": "Pune to Mahabaleshwar Swift Dzire Tour",
      "description": "For your Pune to Mahabaleshwar journey, Morya Cab offers Swift Dzire rentals for a comfortable and scenic ride. Enjoy a peaceful trip to this beautiful hill station with our reliable service."
    },
    {
      "name": "Pune to Shirdi Swift Dzire Tour",
      "description": "Travel to Shirdi in comfort with Morya Cab’s Swift Dzire tour service. Whether for a pilgrimage or leisure trip, enjoy a smooth ride with professional drivers."
    },
    {
      "name": "Pune Airport to Shirdi Tour Packages",
      "description": "Morya Cab offers tour packages from Pune Airport to Shirdi. Our Swift Dzire is ideal for a comfortable and efficient journey, ensuring a hassle-free experience."
    },
    {
      "name": "Pune to Nashik Swift Dzire on Rent",
      "description": "Book a Swift Dzire on rent for your Pune to Nashik journey with Morya Cab. Travel comfortably and efficiently while enjoying the scenic views along the way."
    },
    {
      "name": "Pune to Lonavala Swift Dzire on Rent",
      "description": "Morya Cab offers Swift Dzire rentals for your Pune to Lonavala trip. Enjoy a comfortable and affordable ride to this popular hill station."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Swift Dzire on Rent",
      "description": "Morya Cab provides Swift Dzire on rent for your Pune to Ashtavinayak Darshan journey. We ensure a smooth, convenient, and peaceful travel experience to all the temples."
    },
    {
      "name": "Pune to Panchgani Swift Dzire on Rent",
      "description": "Travel to Panchgani in style with Morya Cab’s Swift Dzire rental service. Perfect for a family outing or a group of friends, we ensure comfort and a pleasant journey."
    },
    {
      "name": "Pune to Lavasa Swift Dzire on Rent",
      "description": "Book a Swift Dzire from Morya Cab for your Pune to Lavasa trip. Enjoy the scenic beauty of Lavasa while traveling in comfort with our professional drivers."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent",
      "description": "For your 5 Jyotirlinga Darshan trip, Morya Cab offers Swift Dzire on rent. Enjoy a comfortable, smooth, and spiritual journey with our well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Pune Darshan Swift Dzire on Rent",
      "description": "Morya Cab offers Swift Dzire rentals for Pune Darshan. Explore the city's religious and cultural landmarks in comfort, with a professional driver at your service."
    },
    {
      "name": "Swift Dzire Rent Near Me",
      "description": "Looking to rent a Swift Dzire near you? Morya Cab provides Swift Dzire rentals in various locations around Pune, ensuring a convenient and reliable service."
    },
    {
      "name": "Swift Dzire Online Booking",
      "description": "Booking a Swift Dzire with Morya Cab is easy with our online booking system. Reserve your vehicle in just a few clicks and enjoy a comfortable ride at affordable rates."
    }
  ],


  tableData: [
    ["Swift Dzire Per Km Rate Pune", "-Swift Dzire Rent Per Km Rate Per Day"],
    ["Swift Dzire Per Km Rate in Pune", "-Swift Dzire Per Km Rate in Pune"],
    ["Swift Dzire Per Km Rate Pimpri Chinchwad", "-Swift Dzire Tour Service Cost"],
    ["Pune to Mahabaleshwar Swift Dzire Tour", "-Pune to Shirdi Swift Dzire Tour"],
    ["Pune Airport to Shirdi Tour Packages", "-Pune to Nashik Swift Dzire on Rent"],
    ["Pune to Lonavala Swift Dzire on Rent", "-Pune to Ashtavinayak Darshan Swift Dzire on Rent"],
    ["Pune to Panchgani Swift Dzire on Rent", "-Pune to Lavasa Swift Dzire on Rent"],
    ["Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent", "-Pune Darshan Swift Dzire On Rent"],
    ["Swift Dzire Rent Near Me", "Swift Dzire Online Booking"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we value your time. Whether you’re heading out for a business trip, family outing, or a sightseeing tour, our Swift Dzire rentals ensure punctual pickups and timely drop-offs, so your trip is always smooth and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Compact Vehicles",
        "WhyChoosedescription": "The Swift Dzire is a perfect blend of comfort and practicality. With its spacious interiors, comfortable seating, and excellent fuel efficiency, it offers an ideal choice for short and medium-distance travels across Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained and experienced, ensuring a safe and pleasant journey. They are familiar with the best routes in Pune and are dedicated to providing you with a smooth travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for Swift Dzire rentals in Pune. We believe in full transparency with no hidden charges, providing you with a clear breakdown of the costs upfront."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "The Swift Dzire comes with modern safety features like airbags, seat belts, and efficient braking systems. We prioritize your safety and comfort throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether it’s an early morning pickup or a late-night return, Morya Cab operates round the clock. Our customer service team is always available to assist you with your travel needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a Swift Dzire with Morya Cab is simple and quick. You can book online via our website or app, or you can contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re exploring Pune or need a reliable vehicle for business travel, we offer customized packages to fit your needs. Let us know your requirements, and we’ll tailor the trip for you."
    }
]

















    }

    const faqData = [
        {
          question: "How can I book a Swift Dzire on rent with Morya Cab?",
          answer: "Booking a Swift Dzire is simple! You can reserve your vehicle online through our website or app, or you can reach out to our customer service team for any assistance."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all our drivers are experienced and trained to handle long-distance travel, ensuring a safe and smooth journey to your destination."
        },
        {
          question: "What types of vehicles are available for rent besides Swift Dzire?",
          answer: "In addition to the Swift Dzire, we offer a variety of vehicles including sedans, SUVs, Tempo Travellers, and premium cars, all maintained to ensure comfort and reliability."
        },
        {
          question: "How do I pay for my Swift Dzire rental?",
          answer: "We offer multiple payment options, including cash, credit/debit cards, and online payment through our app for your convenience."
        },
        {
          question: "Can I book a round trip with a Swift Dzire?",
          answer: "Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll take care of the rest."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "If there are any extra charges, such as waiting time or detours, we will communicate them to you upfront, ensuring complete transparency."
        },
        {
          question: "Can I hire a Swift Dzire for sightseeing in Pune?",
          answer: "Yes, we offer sightseeing tours in and around Pune with the Swift Dzire. Explore the city’s famous attractions comfortably with our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Swift Dzire?",
          answer: "The Swift Dzire can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during booking, and we’ll make necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel with a Swift Dzire?",
          answer: "Yes, we provide corporate travel services, ensuring that business trips are comfortable and hassle-free with the Swift Dzire."
        },
        {
          question: "Why should I choose Morya Cab for Swift Dzire rentals in Pune?",
          answer: "Morya Cab offers a reliable, affordable, and comfortable journey with professional drivers, well-maintained vehicles, and excellent customer service. We guarantee a pleasant travel experience every time."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Kunal Deshmukh',
          role: 'Traveler',
          review: "I rented a Swift Dzire for a trip around Pune. The vehicle was comfortable, clean, and fuel-efficient, perfect for my day trip. The driver was friendly and made the journey smooth. I highly recommend Morya Cab!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Neha Agarwal',
          role: 'Business Traveler',
          review: "We rented a Swift Dzire for a business trip to Pune, and the experience was fantastic. The vehicle was in great condition, and the driver was punctual and professional. We’ll definitely use Morya Cab again for future trips!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "RentalCarReservation",
        "name": "Swift Dzire on Rent in Pune",
        "description": "Rent Swift Dzire for local and outstation trips from Pune. Available for tours to Mahabaleshwar, Shirdi, Nashik, Lonavala, Ashtavinayak, and more.",
        "provider": {
          "@type": "Organization",
          "name": "Pune Swift Dzire Rentals",
          "url": "https://www.puneswiftdzirerentals.com",
          "telephone": "+91-9999999999",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Flat No. 101, Kothrud, Pune",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411038",
            "addressCountry": "IN"
          }
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": 12,
          "eligibleRegion": {
            "@type": "Place",
            "name": "Pune"
          },
          "priceValidUntil": "2025-12-31",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "12",
            "unitCode": "KM",
            "description": "Rate per km for Swift Dzire rental in Pune"
          }
        },
        "keywords": "Swift Dzire on rent Pune, Swift Dzire rental Pune, Pune to Mahabaleshwar Swift Dzire tour, Pune to Shirdi Swift Dzire tour, Pune to Nashik Swift Dzire on rent, Pune to Lonavala Swift Dzire on rent, Pune to Ashtavinayak Darshan Swift Dzire on rent, Pune to Panchgani Swift Dzire on rent, Pune to Lavasa Swift Dzire on rent, Pune to 5 Jyotirlinga Darshan Swift Dzire on rent, Pune Darshan Swift Dzire on rent, Swift Dzire rent near me, Swift Dzire online booking"
      };
      


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Swift Dzire on Rent in Pune | Book Swift Dzire for Outstation and Local Trips | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Book Swift Dzire on rent for outstation and local trips from Pune. Affordable rates for trips to Mahabaleshwar, Shirdi, Nashik, Lonavala, and more."
  />
  <meta
    name="keywords"
    content="Swift Dzire on rent Pune, Swift Dzire rental Pune, Pune to Mahabaleshwar Swift Dzire tour, Pune to Shirdi Swift Dzire tour, Pune to Nashik Swift Dzire on rent, Pune to Lonavala Swift Dzire on rent, Pune to Ashtavinayak Darshan Swift Dzire on rent, Pune to Panchgani Swift Dzire on rent, Pune to Lavasa Swift Dzire on rent, Pune to 5 Jyotirlinga Darshan Swift Dzire on rent, Pune Darshan Swift Dzire on rent, Swift Dzire rent near me, Swift Dzire online booking"
  />
  <meta property="og:title" content="Swift Dzire on Rent in Pune | Book Swift Dzire for Outstation and Local Trips" />
  <meta
    property="og:description"
    content="Book Swift Dzire on rent for outstation and local trips from Pune. Affordable rates for trips to Mahabaleshwar, Shirdi, Nashik, Lonavala, and more."
  />
  <meta property="og:url" content="https://www.puneswiftdzirerentals.com" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://www.puneswiftdzirerentals.com/images/swift-dzire-pune.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Swiftdezireonrentinpune;